module.exports = __webpack_public_path__ + "static/postIt06-4f58acc8a8f2747265d80f0894b8cac9.svg";